import { takeEvery, call, put } from "redux-saga/effects";
import {
  // FETCH_IMAGES_REQUEST,
  PUT_IMAGES_REQUEST,
  GET_PRESIGNED_URLS_REQUEST,
  GET_PRESIGNED_GET_URLS_REQUEST,
  GET_TAGGED_MEDIA_REQUEST,
  getTaggedMediaSuccess,
  putImagesSuccess,
  getPresignedUrlsSuccess,
  // getPresignedGetUrlsSuccess,
} from "../actions/imageActions";
import {
  fetchPresignedUrlsFromApi,
  getPresignedGetUrlsFromApi,
  // putImagesToApi,
  getTaggedMediaFromApi,
} from "../apis/imageApi";

// Saga to handle the fetch images action
function* getTaggedMediaSaga(action) {
  try {
    const payload = {
      operationType: "GET_TAGGED_MEDIA",
      entityType: "IMAGE",
      tags: action.payload,
    };
    // console.log(
    //   `PMM - SF - saga - getTaggedMediaSaga - fetching URLs for files: ${JSON.stringify(
    //     payload
    //   )}`
    // );

    const libraryCards = yield call(getTaggedMediaFromApi, action.payload);
    // console.log(
    //   `PMM - SF - saga - getTaggedMediaSaga - response libraryCards is: ${JSON.stringify(
    //     libraryCards
    //   )}`
    // );
    // yield put(getTaggedMediaSuccess(libraryCards));
  } catch (error) {
    console.error(error); // Handle error
  }
}

// Saga to handle the get presigned URLs action
function* getPresignedUrlsSaga(action) {
  try {
    const payload = {
      operationType: "GET_PRESIGNED_URLS",
      entityType: "IMAGE",
      filenames: action.payload,
    };
    // console.log(
    //   `PMM - SF - saga - getPresignedUrlsSaga - fetching New URLs for files: ${JSON.stringify(
    //     payload
    //   )}`
    // );
    const urls = yield call(fetchPresignedUrlsFromApi, action.payload);
    // console.log(
    //   `PMM - SF - saga - getPresignedUrlsSaga - received presigned URLs: ${JSON.stringify(
    //     urls
    //   )}`
    // );
    yield put(getPresignedUrlsSuccess(urls)); // Dispatch success action
  } catch (error) {
    console.error("Error fetching pre-signed URLs:", error); // Handle error
  }
}

function* getPresigneGetdUrlsSaga(action) {
  try {
    const payload = {
      operationType: "GET_THUMBNAIL_URLS",
      entityType: "IMAGE",
      filenames: action.payload,
    };
    // console.log(
    //   `PMM - SF - saga - getPresignedGetUrlsSaga - fetching New URLs for files: ${JSON.stringify(
    //     payload
    //   )}`
    // );
    const urls = yield call(getPresignedGetUrlsFromApi, action.payload);
    // console.log(
    //   `PMM - SF - saga - getPresigneGetdUrlsSaga - received presigned Get URLs: ${JSON.stringify(
    //     urls
    //   )}`
    // );
    yield put(getTaggedMediaSuccess(urls)); // Dispatch success action
  } catch (error) {
    console.error("Error fetching pre-signed get URLs:", error); // Handle error
  }
}

function* watchImageActions() {
  yield takeEvery(GET_TAGGED_MEDIA_REQUEST, getTaggedMediaSaga);
  // yield takeEvery(PUT_IMAGES_REQUEST, putImagesSaga);
  yield takeEvery(GET_PRESIGNED_URLS_REQUEST, getPresignedUrlsSaga);
  yield takeEvery(GET_PRESIGNED_GET_URLS_REQUEST, getPresigneGetdUrlsSaga);
}

export default watchImageActions;
